import { render, staticRenderFns } from "./switchContainer.vue?vue&type=template&id=7a666ce5"
import script from "./switchContainer.vue?vue&type=script&lang=js"
export * from "./switchContainer.vue?vue&type=script&lang=js"
import style0 from "./switchContainer.vue?vue&type=style&index=0&id=7a666ce5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports